export const shouldOpenLink = (osName: string, e: MouseEvent) => {
  if (osName === "macos") return e.metaKey;
  else return e.ctrlKey;
};
